import { handleException } from '~/modules/utilities/error_utilities';
import {
    generateLeadData,
    getListingFromStore,
    getListingIdFromQueryString,
    getQueryStringFromRouter,
    getUserActivityUrl,
    getUserInstallUrl,
    postKeepAlive,
    UserActivityPayload,
    USER_SOURCE,
} from '~/modules/utilities/userActivityUtilities';

export async function createUserActivity(type: string): Promise<void> {
    try {
        const payload = createBasePayload(type);
        const url = getUserActivityUrl(payload.listingId);
        await postKeepAlive(url, payload);
    } catch (error) {
        handleException(error, 'simplifiedTrialsService.createUserActivity');
    }
}

export async function createUserInstall(type: string): Promise<void> {
    try {
        const payload = createBasePayload(type);
        const url = getUserInstallUrl(payload.listingId);
        await postKeepAlive(url, payload);
    } catch (error) {
        handleException(error, 'simplifiedTrialsService.createUserInstall');
    }
}

function createBasePayload(type: string): UserActivityPayload {
    const queryString = getQueryStringFromRouter();
    const listingId = getListingIdFromQueryString(queryString);

    if (!listingId) {
        throw new Error('Listing ID not found in query string');
    }

    const listing = getListingFromStore(listingId);

    return {
        listingId: listing?.appExchangeId || listingId,
        type,
        source: USER_SOURCE,
        userAgent: navigator.userAgent,
        lead: generateLeadData(listingId),
    };
}
